<template>
  <v-dialog
    :value="value"
    max-width="480"
    persistent
    @input="$emit('input', $event)"
  >
    <v-card>
      <v-card-title class="text-h6">
        Open new batch
      </v-card-title>
      <v-card-text>
        <v-row dense>
          <v-col
            cols="12"
            sm="6"
          >
            <label class="text-caption grey--text d-block mb-1">Start date</label>
            <date-picker
              v-model="startDate"
              type="date"
              format="YYYY-MM-DD"
              value-type="format"
              :disabled-date="disableAfterEnd"
              input-class="mx-input"
              style="width: 100%;"
            />
          </v-col>
          <v-col
            cols="12"
            sm="6"
          >
            <label class="text-caption grey--text d-block mb-1">End date</label>
            <date-picker
              v-model="endDate"
              type="date"
              format="YYYY-MM-DD"
              value-type="format"
              :disabled-date="disableBeforeStart"
              input-class="mx-input"
              style="width: 100%;"
            />
          </v-col>
        </v-row>
        <div
          v-if="errorMessage"
          class="error--text text-caption mt-2"
        >
          {{ errorMessage }}
        </div>
      </v-card-text>
      <v-card-actions class="px-4 pb-4">
        <v-spacer />
        <v-btn
          text
          :disabled="submitting"
          @click="$emit('input', false)"
        >
          Cancel
        </v-btn>
        <v-btn
          color="primary"
          depressed
          :loading="submitting"
          :disabled="!canSubmit"
          @click="submit"
        >
          Open batch
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

const ONE_YEAR_MS = 366 * 24 * 60 * 60 * 1000;

export default {
  name: 'BulkNewBatchDialog',
  components: { DatePicker },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    submitting: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      startDate: null,
      endDate: null,
    };
  },
  computed: {
    errorMessage() {
      if (!this.startDate || !this.endDate) return '';
      if (new Date(this.endDate) < new Date(this.startDate)) {
        return 'End date must be on or after start date.';
      }
      const span = new Date(this.endDate).getTime() - new Date(this.startDate).getTime();
      if (span > ONE_YEAR_MS) return 'Date range cannot exceed one year.';
      return '';
    },
    canSubmit() {
      return !!this.startDate && !!this.endDate && !this.errorMessage;
    },
  },
  watch: {
    value(open) {
      if (open) {
        this.startDate = null;
        this.endDate = null;
      }
    },
  },
  methods: {
    disableBeforeStart(date) {
      if (!this.startDate) return false;
      return date < new Date(this.startDate);
    },
    disableAfterEnd(date) {
      if (!this.endDate) return false;
      return date > new Date(this.endDate);
    },
    submit() {
      if (!this.canSubmit) return;
      this.$emit('submit', { start_date: this.startDate, end_date: this.endDate });
    },
  },
};
</script>
